import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ProductsDataSource } from './products.datasource';
import { Product } from '../models/products.types';
import { ProductMapper } from './products.mapper';
import { Period } from '../../../core/constants/periods';

@Injectable({ providedIn: 'root' })
export class ProductsService {
  private dataSource = inject(ProductsDataSource);
  private mapper = inject(ProductMapper);

  getProducts(projectId: string, solutionId: string, period: Period): Observable<Product[]> {
    return this.dataSource
      .getProducts(projectId, solutionId, period)
      .pipe(map(response => this.mapper.mapToProducts(response)));
  }
}
